import { render, staticRenderFns } from "./BetDataTable.vue?vue&type=template&id=13dcb801&scoped=true&"
import script from "./BetDataTable.vue?vue&type=script&lang=js&"
export * from "./BetDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BetDataTable.vue?vue&type=style&index=0&id=13dcb801&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dcb801",
  null
  
)

export default component.exports